module.exports = __webpack_public_path__ + "static/media/lupa.9c12a262.svg";